import trainingAccommodations from './models/TrainingAccommodationsHelper';

export default { trainingAccommodations };
